<app-page-title [title]="'Request shipment of hardcopy score report'"></app-page-title>
<br />
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <p>
                If you wish to submit your scores to an organization (i.e. Immigration, Refugees and Citizenship Canada), you can download a free PDF copy of your CELPIP Official Score Report by clicking on the Check Scores button in your CELPIP Account.
                <p>
                    You may choose to order a hardcopy of your CELPIP Official Score Report, which will be mailed to the address you registered with, for a fee of $20.00 CAD each. Priority shipping is available for an additional fee and a tracking number will be provided.
                    <p>
                        Your scores are going to be available in your CELPIP Account for up to two years from the date of your CELPIP Test.
                        <p>
                            Please note that there are no refunds or exchanges on additional Score Reports or shipping methods purchased online through our website.
                        </p>
        </div>
    </div>
</div>
<h4>Test Information</h4>

<div
    class="row"
    *ngIf="testInfo"
>
    <div class="col-md-6">
        <p>Registration Number: {{regId}}</p>
        <p [hidden]="testInfo.isWebDelivery">Test Centre: {{testInfo.testCentreName}}</p>
        <p [hidden]="testInfo.isWebDelivery">Test Centre Location: {{testInfo.testCentreLocation}}</p>
        <p *ngIf="testInfo.isWebDelivery">Web Delivered Test</p>
    </div>
    <div class="col-md-6">
        <p>Test Date: {{testInfo.testDateTime | date}}</p>
        <p>Test Type: {{testInfo.testTypeName}}</p>
    </div>
</div>

<br />

<h4>Shipping Detail</h4>

<div class="row survey">
    <form
        name="order-score-hard-copy-form"
        novalidate
    >
        <div class="col-md-12">
            <div class="form-group surveyQuestion">
                <label class="questionText">Select delivery method:</label>
                <div
                    class="my-3"
                    style="color:red"
                >Please note that it can take up to one week for orders to be processed, and the delivery timelines indicated below are applicable after processing has occurred. This includes Priority Shipping orders.</div>
                <div
                    class="radio"
                    *ngFor="let serviceProduct of hardcopyScoresServiceProducts"
                >
                    <label class="choice">
                        <input
                            type="radio"
                            name="selectedHardcopyScoresServiceProduct"
                            (click)="selectHardcopyScoresServiceProduct(serviceProduct)"
                            [checked]="serviceProduct == selectedserviceProduct"
                        >
                        {{getHardcopyScoresServiceDisplayName(serviceProduct)}}
                    </label>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="row">
    <div class="col-md-12 bottomButtons">
        <a
            [routerLink]="['/my-account']"
            class="btn btn-primary m-1"
        >Back</a>
        <button
            type="button"
            name="confirmationYesBtn"
            class="btn btn-primary m-1"
            (click)="addScoreReportToCart()"
        >
            <span class="glyphicon glyphicon-plus"></span> Add to cart
        </button>
    </div>
</div>
